import React, { useState } from "react";
import classNames from "classnames";
import styles from "./copy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCopy } from "@fortawesome/free-solid-svg-icons";
import copy from "copy-to-clipboard";
import { isEmpty } from "ramda";

const Copy = ({className, data}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const copiedData = !isEmpty(data) ? data : ' ';
    copy(copiedData);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    } , 1000);
  };

  return (
    <div className={classNames(className, "Entity")} onClick={handleCopy}>
      <FontAwesomeIcon icon={copied ? faCheck : faCopy} className={"text-primary"}/>
    </div>
  );
};

export default Copy;